import DialogForm from "@/components/DialogForm/index.vue";
import { defineComponent, computed, reactive, watch, getCurrentInstance } from "vue";
import { useModelStore } from "./model-mixin";
import { Message } from "element-ui";
import { isFeModelId } from "@/store/creative/common/category";
import _ from "lodash";
export default defineComponent({
    components: {
        DialogForm: DialogForm
    },
    props: {
        dialogConfig: {
            type: Object,
            required: true
        },
        dialogValue: {
            type: Object,
            required: true
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var fillShaderFilePath = function fillShaderFilePath(data) {
            if (data.shader_prefix) {
                var shader = shaderResourceList.value.find(function(item) {
                    return item.prefix === data.shader_prefix;
                });
                if (shader) {
                    data.shader_file_path = shader.real_file_path;
                }
            } else {
                data.shader_file_path = "";
            }
            return data;
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var store = root.$store;
        var ref = useModelStore(store), textureResourceList = ref.textureResourceList, shaderResourceList = ref.shaderResourceList, modelMaterialList = ref.modelMaterialList;
        var dialogFormConfig = reactive({
            labelPosition: "left",
            labelWidth: "150px",
            size: "mini"
        });
        watch(function() {
            return props.dialogConfig.visible;
        }, function(val) {
            if (val) {
                console.log("val", val);
            }
        });
        var dialogItemList = computed(function() {
            return [
                {
                    label: "\u4E2D\u6587\u540D\u79F0",
                    type: "input",
                    prop: "name"
                },
                {
                    label: "\u82F1\u6587\u540D\u79F0",
                    type: "input",
                    prop: "name_en"
                },
                {
                    label: "\u6A21\u578B\u7684\u539F\u8272\u8D34",
                    type: "select",
                    prop: "texture_color_prefix",
                    params: {
                        clearable: true,
                        filterable: true,
                        options: textureResourceList.value.map(function(item) {
                            return {
                                label: item.file_name,
                                value: item.prefix
                            };
                        })
                    }
                },
                {
                    label: "\u6A21\u578B\u7684\u6CD5\u7EBF\u8D34\u56FE",
                    type: "select",
                    prop: "texture_normal_prefix",
                    params: {
                        clearable: true,
                        filterable: true,
                        options: textureResourceList.value.map(function(item) {
                            return {
                                label: item.file_name,
                                value: item.prefix
                            };
                        })
                    }
                },
                {
                    label: "\u6A21\u578B\u7684pbr\u8D34\u56FE",
                    type: "select",
                    prop: "texture_pbr_prefix",
                    params: {
                        clearable: true,
                        filterable: true,
                        options: textureResourceList.value.map(function(item) {
                            return {
                                label: item.file_name,
                                value: item.prefix
                            };
                        })
                    }
                },
                {
                    label: "\u6A21\u578B\u7684\u81EA\u53D1\u5149\u8D34\u56FE",
                    type: "select",
                    prop: "texture_emissive_prefix",
                    params: {
                        clearable: true,
                        filterable: true,
                        options: textureResourceList.value.map(function(item) {
                            return {
                                label: item.file_name,
                                value: item.prefix
                            };
                        })
                    }
                },
                {
                    label: "\u6A21\u578B\u7684\u73AF\u5883\u906E\u853D\u8D34\u56FE",
                    type: "select",
                    prop: "texture_occlusion_prefix",
                    params: {
                        clearable: true,
                        filterable: true,
                        options: textureResourceList.value.map(function(item) {
                            return {
                                label: item.file_name,
                                value: item.prefix
                            };
                        })
                    }
                },
                {
                    label: "\u6A21\u578B\u7684\u6362\u8272\u906E\u7F69\u8D34\u56FE",
                    type: "select",
                    prop: "texture_hsvMask_prefix",
                    params: {
                        clearable: true,
                        filterable: true,
                        options: textureResourceList.value.map(function(item) {
                            return {
                                label: item.file_name,
                                value: item.prefix
                            };
                        })
                    }
                },
                {
                    // 内置材质资源不允许修改, 编辑中不允许修改
                    visible: !props.dialogValue.is_default,
                    label: "\u6750\u8D28\u8D44\u6E90",
                    type: "select",
                    prop: "shader_prefix",
                    rules: [
                        {
                            required: true
                        }, 
                    ],
                    params: {
                        // 编辑中不允许修改，因为修改这个值会直接影响到皮肤的 uuid ，会导致新增一个皮肤，建议手动删除再新增
                        disabled: props.dialogConfig.deleteLabel === "\u5220\u9664\u76AE\u80A4",
                        clearable: true,
                        filterable: true,
                        options: shaderResourceList.value.map(function(item) {
                            return {
                                label: item.file_name,
                                value: item.prefix
                            };
                        })
                    }
                },
                {
                    // visible:
                    //   !isFeModelId(props.dialogValue.id) && !hsvModel.value[0].disabled,
                    label: "\u90E8\u4F4D\u4E00\u4E2D\u6587\u540D\u79F0",
                    type: "input",
                    prop: "part_one_name"
                },
                {
                    // visible:
                    //   !isFeModelId(props.dialogValue.id) && !hsvModel.value[0].disabled,
                    label: "\u90E8\u4F4D\u4E00\u82F1\u6587\u540D\u79F0",
                    type: "input",
                    prop: "part_one_name_en"
                },
                {
                    // visible:
                    //   !isFeModelId(props.dialogValue.id) && !hsvModel.value[1].disabled,
                    label: "\u90E8\u4F4D\u4E8C\u4E2D\u6587\u540D\u79F0",
                    type: "input",
                    prop: "part_two_name"
                },
                {
                    // visible:
                    //   !isFeModelId(props.dialogValue.id) && !hsvModel.value[1].disabled,
                    label: "\u90E8\u4F4D\u4E8C\u82F1\u6587\u540D\u79F0",
                    type: "input",
                    prop: "part_two_name_en"
                },
                {
                    // visible:
                    //   !isFeModelId(props.dialogValue.id) && !hsvModel.value[2].disabled,
                    label: "\u90E8\u4F4D\u4E09\u4E2D\u6587\u540D\u79F0",
                    type: "input",
                    prop: "part_three_name"
                },
                {
                    // visible:
                    //   !isFeModelId(props.dialogValue.id) && !hsvModel.value[2].disabled,
                    label: "\u90E8\u4F4D\u4E09\u82F1\u6587\u540D\u79F0",
                    type: "input",
                    prop: "part_three_name_en"
                },
                {
                    // visible:
                    //   !isFeModelId(props.dialogValue.id) && !hsvModel.value[3].disabled,
                    label: "\u90E8\u4F4D\u56DB\u4E2D\u6587\u540D\u79F0",
                    type: "input",
                    prop: "part_four_name"
                },
                {
                    // visible:
                    //   !isFeModelId(props.dialogValue.id) && !hsvModel.value[3].disabled,
                    label: "\u90E8\u4F4D\u56DB\u82F1\u6587\u540D\u79F0",
                    type: "input",
                    prop: "part_four_name_en"
                }, 
            ];
        });
        var handleSubmit = function() {
            var formModelMaterial = fillShaderFilePath(props.dialogValue);
            var tempMaterialList = _.cloneDeep(modelMaterialList.value);
            var targetIndex = tempMaterialList.findIndex(function(item) {
                return item.id === props.dialogValue.id;
            });
            if (targetIndex === -1) {
                tempMaterialList.push(formModelMaterial);
                store.commit("creative/modelEditor/setModelMaterialList", tempMaterialList);
            } else {
                store.commit("creative/modelEditor/setModelMaterialListByIndex", {
                    index: targetIndex,
                    data: fillShaderFilePath(props.dialogValue)
                });
            }
            emit("callback");
        };
        var handleDelete = function() {
            if (props.dialogValue.is_default) {
                Message.error("\u5F53\u524D\u76AE\u80A4\u6750\u8D28\u4E3A\u7A7A\uFF0C\u5E76\u4E14\u5B58\u5728\u6750\u8D28 id\uFF0C\u5E73\u53F0\u5224\u65AD\u53EF\u80FD\u662F\u6A21\u578B\u5185\u7F6E\u6750\u8D28\uFF0C\u4E0D\u5141\u8BB8\u5220\u9664");
                return;
            }
            var formModelMaterial = fillShaderFilePath(props.dialogValue);
            var temp = _.cloneDeep(modelMaterialList.value);
            var index = temp.findIndex(function(item) {
                return isFeModelId(formModelMaterial.id) && _.isEqual(item, formModelMaterial) || !isFeModelId(formModelMaterial.id) && item.id === formModelMaterial.id;
            });
            if (index !== -1) {
                temp.splice(index, 1);
                store.commit("creative/modelEditor/setModelMaterialList", temp);
                store.commit("creative/modelEditor/deleteMaterialsConfigById", formModelMaterial.id);
                store.commit("creative/modelEditor/setMaterialId", "");
                store.commit("creative/modelEditor/setMaterialPath", "");
            }
            emit("callback");
        };
        return {
            dialogFormConfig: dialogFormConfig,
            handleSubmit: handleSubmit,
            dialogItemList: dialogItemList,
            handleDelete: handleDelete
        };
    }
});
